import classNames from 'classnames'
import { observable, runInAction } from 'mobx'
import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'

import { ReactComponent as Play } from '../../../../assets/Rectangle 6.svg'
import { ReactComponent as Stop } from '../../../../assets/Rectangle 7.svg'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
export const Visitor = observable({
  name: '',
})

const Intro = observer(() => {
  const video = useRef<any>(null)
  const [isFocus, setFocus] = useState(false)
  const [isPlay, setPlay] = useState(false)
  const [user, setUser] = useState('')
  const intro = ContentState.career.intro

  useEffect(() => {
    if (!video.current) return
    if (isPlay) {
      video.current.play()
      document.querySelector('.intro-career__content')?.classList.add('playing')
    } else {
      video.current.pause()
      document
        .querySelector('.intro-career__content')
        ?.classList.remove('playing')
    }
  }, [isPlay])

  useEffect(() => {
    ;(video.current as HTMLVideoElement).addEventListener('playing', (e) => {
      setPlay(true)
    })
    ;(video.current as HTMLVideoElement).addEventListener('pause', (e) => {
      setPlay(false)
    })
    ;(video.current as HTMLVideoElement).addEventListener('seeking', (e) => {
      setPlay(true)
    })
    ;(video.current as HTMLVideoElement).addEventListener('ended', (e) => {
      setPlay(false)
      ;(video.current as HTMLVideoElement).load()
    })
  }, [])

  if (!intro) return <></>
  return (
    <section className="intro-career">
      <div className="intro-career__content">
        <div
          className="intro-career__title"
          dangerouslySetInnerHTML={{ __html: intro.title }}
        ></div>
        <div className="intro-career__row">
          {!isPlay && (
            <div className="intro-career__but" onClick={() => setPlay(true)}>
              <Play />
            </div>
          )}
        </div>
        <div className="intro-career__form">
          <div className="intro-career__input">
            <input
              placeholder={isFocus ? '' : intro.placeholder}
              className="input"
              onChange={(e) => {
                setUser(e.target.value)
              }}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              value={user}
            />
          </div>
          <div
            className={classNames('button white', !user.length && 'disabled')}
            dangerouslySetInnerHTML={{ __html: intro.butText }}
            onClick={() => {
              if (!user.length) return
              runInAction(() => {
                Visitor.name = user
              })
              setUser('')

              const body = document.body.getBoundingClientRect(),
                next: any = document.querySelector('.about-career')

              if (!next) return
              const bodyTop = body.top,
                nextTop = next!.getBoundingClientRect()

              const offset = nextTop.top - bodyTop

              window.scroll({
                top: offset,
                behavior: 'smooth',
              })
            }}
          ></div>
        </div>
      </div>
      <div className="intro-career__bg">
        <video
          poster={intro.poster}
          preload="preload"
          src={intro.src}
          ref={video}
          controls={isPlay}
        >
          <source src={intro.src} type="video/mp4"></source>
        </video>
      </div>
    </section>
  )
})

export default Intro
